import { Dispatch } from "redux";
import {
    setServiceAssertionPerformanceComparisonReferenceData,
    setServiceAssertionPerformanceComparisonReferenceDataLoading
} from "@redux/actions/service-assertion-performance-comparison-actions";
import { getServiceAssertionPerformanceReferenceDataRequest } from "@requests/reports/get-service-assertion-performance-reference-data";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getServiceAssertionPerformanceComparisonReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setServiceAssertionPerformanceComparisonReferenceDataLoading(true));
    const { data, error } = await getServiceAssertionPerformanceReferenceDataRequest();
    if (data) {
        dispatch(setServiceAssertionPerformanceComparisonReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setServiceAssertionPerformanceComparisonReferenceDataLoading(false));
    }
};